import CardServices from "../../../utils/cardServices";

export default function Servicos({ definicoesSistema }) {
    const serviceStatus = (servico) => definicoesSistema?.servicos.includes(servico) ?? false;

    return (
        <div
            className="tw-flex tw-items-center tw-min-h-[50vh] tw-shadow-lg"
            style={{
                backgroundImage: 'url(/img/backGrounds/BgComprimido.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
                marginTop: -5,
            }}
        >
            <div className="tw-w-full tw-max-w-5xl tw-mx-auto tw-px-4">

                <h2 className="tw-text-center tw-text-[25px] tw-font-bold tw-text-gray-800 tw-my-8 tw-tracking-widest tw-uppercase">
                    Serviços
                </h2>

                <div className="tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-gap-8 tw-pb-10">
                    <CardServices status={serviceStatus('informacoes')} icone={'/icones/Informacoes.svg'} nomeService={'Informações'} link={'/central-de-informacoes'} />
                    <CardServices status={serviceStatus('agenda')} icone={'/icones/Agenda2.svg'} nomeService={'Licenciamento de Estabelecimento Farmacêutico'} link={'/agenda-disponivel'} />
                    <CardServices status={serviceStatus('renovacaoAutorizacao')} icone={'/icones/renovacaoLicenciamento.svg'} nomeService={'Renovação da Autorização de Exercício Farmacêutico'} link={'/solicitacao-de-renovacao-de-estabelecimento'} />
                    <CardServices status={serviceStatus('importacaoExportacao')} icone={'/icones/Import_export.svg'} nomeService={'Importação & Exportação'} link={'/importacao-e-exportacao'} />
                    <CardServices status={serviceStatus('certificadoProdutosControlados')} icone={'/icones/Import_export.svg'} nomeService={'Certificado de Produtos Controlados'} link={'inspeccao-regulatoria/solicitacao/certificado-produto-controlado/Produtos Controlados'} />
                    <CardServices status={serviceStatus('desalfandegamento')} icone={'/icones/Desalfandegar.svg'} nomeService={'Desalfandegamento'} link={'/solicitacao-de-desalfandegamento'} />
                    <CardServices status={serviceStatus('analiseLaboratorial')} icone={'/icones/controleQualidade/controloQualidade.svg'} nomeService={'Controlo de Qualidade'} link={'/opcoes/controlo-de-qualidade'} />
                    <CardServices status={serviceStatus('farmacovigilancia')} icone={'/icones/controleQualidade/solicitacoesAnalise.svg'} nomeService={'Farmacovigilância e Ensaios Clínicos'} link={'/farmacovigilancia-forlumarios'} />
                </div>
            </div>
        </div>
    );
}
